import React from 'react';
import _ from 'lodash';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useDispatch } from 'react-redux';
import { useMutation } from 'react-fetching-library';
import { Box, Stack, Button, TextField, Alert, FormLabel, RadioGroup, FormControlLabel, Radio, MenuItem, InputLabel, Select } from '@mui/material';
import { createPaymentAction, updatePaymentAction } from '../../../../../../services/request';
import { updateOrder } from '../../../../../../services/redux-actions';
import { PAYMENT_KINDS } from '../../../../../../utils/consts';

const validationSchema = Yup.object({
  title: Yup.string().required('To pole jest wymagane'),
  to_pay: Yup.number().required('To pole jest wymagane'),
  regard_year: Yup.number().nullable()
    .when('payment_kind', {
      is: PAYMENT_KINDS.KIND_MONTHLY, // alternatively: (val) => val == true
      then: schema => schema.required('To pole jest wymagane'),
      otherwise: schema => schema
    }),
  regard_month: Yup.number().nullable()
    .when('payment_kind', {
      is: PAYMENT_KINDS.KIND_MONTHLY, // alternatively: (val) => val == true
      then: schema => schema.required('To pole jest wymagane'),
      otherwise: schema => schema
    })
});


const CreatePayment = ({ order, handleClose, positionToEdit = null, updateOrderList = () => {} }) => {
  const dispatch = useDispatch();
  const { error, mutate: mutateCreate } = useMutation(createPaymentAction);
  const { mutate: mutatePatch } = useMutation(updatePaymentAction);
  const [month_year_visible, setMonth_year_visible] = React.useState(positionToEdit == null ? false : positionToEdit.payment_kind === PAYMENT_KINDS.KIND_MONTHLY);
  const currentDate = new Date();
  const editable = positionToEdit == null;

  let initialValues = {
    order: order.id,
    status: 1,
    title: '',
    to_pay: '',
    purchaser: order.guardian,
    participant: order.participant_name,
    contract_number: order.identifier,
    payment_kind: PAYMENT_KINDS.KIND_OTHER,
    regard_month: currentDate.getMonth() + 1,
    regard_year: currentDate.getFullYear()
  };
  if (positionToEdit != null) {
    initialValues = {
      title: positionToEdit.title,
      to_pay: positionToEdit.to_pay,
      payment_kind: positionToEdit.payment_kind,
      // te ustawiamy zeby nie bylo null, a i tak sa kasowane jezeli potrzebne przed wyslaniem
      regard_month: _.defaultTo(positionToEdit.regard_month, currentDate.getMonth() + 1),
      regard_year: _.defaultTo(positionToEdit.regard_year, currentDate.getFullYear())
    };
    // if (positionToEdit.payment_kind === PAYMENT_KINDS.KIND_MONTHLY) {
    //   setMonth_year_visible(true);
    // }
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    validateOnChange: false,
    onSubmit: values => {
      handleSubmit(values);
    }
  });

  const handleSubmit = async values => {
    let copiedValues = JSON.parse(JSON.stringify(values));
    if (copiedValues.payment_kind != PAYMENT_KINDS.KIND_MONTHLY) {
      copiedValues.regard_month = null;
      copiedValues.regard_year = null;
    }
    if (positionToEdit == null) {
      console.log('Dodaje platnosc.');
      console.log(copiedValues);

      const { error, payload } = await mutateCreate(copiedValues);
      if (!error) {
        const updatedOrder = { ...order, order_payments: [payload, ...order.order_payments] };
        dispatch(updateOrder(updatedOrder));
        updateOrderList(updatedOrder);
        handleClose();
      }
    } else {
      console.log('Edytuje platnosc.');
      copiedValues = {
        payment_kind: copiedValues.payment_kind,
        regard_month: copiedValues.regard_month,
        regard_year: copiedValues.regard_year
      };
      console.log(copiedValues);

      const { error, payload } = await mutatePatch(positionToEdit.id, copiedValues);

      if (!error) {
        const updatedOrder = { ...order, order_payments: order.order_payments.map(payment => payment.id !== payload.id ? payment : payload) };
        dispatch(updateOrder(updatedOrder));
        // handleOpenSnackbar('success', 'Płatność została dodana');
        handleClose();
      }
    }


  };

  const handleKindChange = (event, value) => {
    if (value == PAYMENT_KINDS.KIND_MONTHLY) {
      formik.values.regard_month = currentDate.getMonth() + 1;
      formik.values.regard_year = currentDate.getFullYear();

      setMonth_year_visible(true);
    } else {
      setMonth_year_visible(false);
    }
    formik.values.payment_kind = Number(value);
    formik.handleChange(event, value);
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <Stack>
        <TextField
          id="title"
          label="Tytuł"
          variant="outlined"
          disabled={!editable}
          value={formik.values.title}
          onChange={formik.handleChange}
          error={formik.errors.title && formik.touched.title}
          helperText={formik.errors.title}
        />
        <Box height={5} />
        <FormLabel id="demo-radio-buttons-group-label">Rodzaj płatności</FormLabel>
        <RadioGroup
          row
          aria-labelledby="demo-radio-buttons-group-label"
          name="radio-buttons-group"
          value={formik.values.payment_kind}
          onChange={handleKindChange}
        >
          <FormControlLabel value={PAYMENT_KINDS.KIND_OTHER} control={<Radio />} label="Inna" />
          <FormControlLabel value={PAYMENT_KINDS.KIND_MONTHLY} control={<Radio />} label="Miesięczna" />
          <FormControlLabel value={PAYMENT_KINDS.KIND_YEARLY_FEE} control={<Radio />} label="Roczna" />
        </RadioGroup>
        <Box height={15} />
        {/* <InputLabel id="dotyczy-miesiaca-select-label">Dotyczy miesiąca</InputLabel> */}
        <Stack direction="row" spacing={2} sx={{ display: month_year_visible ? 'block' : 'none' }}>
          <Select
            // labelId="dotyczy-miesiaca-select-label"
            id="regard_month"
            name="regard_month"
            label="Dotyczy miesiąca"
            variant="outlined"
            value={formik.values.regard_month}
            onChange={formik.handleChange}
            error={formik.errors.regard_month && formik.touched.regard_month}
            // helperText={formik.errors.regard_month}
            // onChange={function () {}}
          >
            <MenuItem value={1}>Styczeń</MenuItem>
            <MenuItem value={2}>Luty</MenuItem>
            <MenuItem value={3}>Marzec</MenuItem>
            <MenuItem value={4}>Kwiecień</MenuItem>
            <MenuItem value={5}>Maj</MenuItem>
            <MenuItem value={6}>Czerwiec</MenuItem>
            <MenuItem value={7}>Lipiec</MenuItem>
            <MenuItem value={8}>Sierpień</MenuItem>
            <MenuItem value={9}>Wrzesień</MenuItem>
            <MenuItem value={10}>Październik</MenuItem>
            <MenuItem value={11}>Listopad</MenuItem>
            <MenuItem value={12}>Grudzień</MenuItem>
          </Select>
          <TextField
            id="regard_year"
            label="Dotyczy roku"
            type="number"
            variant="outlined"
            onChange={formik.handleChange}
            value={formik.values.regard_year}
            error={formik.errors.regard_year && formik.touched.regard_year}
            helperText={formik.errors.regard_year}
          />
        </Stack>
        <Box height={15} />
        <TextField
          id="to_pay"
          label="Kwota (zł)"
          variant="outlined"
          type="number"
          disabled={!editable}
          value={formik.values.to_pay}
          onChange={formik.handleChange}
          error={formik.errors.to_pay && formik.touched.to_pay}
          helperText={formik.errors.to_pay}
        />
      </Stack>
      {error
        ? <>
          <Box height={40} />
          <Alert severity="error">Nie udało się dodać opłaty</Alert>
        </>
        : null}

      <Box height={40} />
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Button variant="outlined" style={{ flex: '0.45' }} onClick={handleClose}>Anuluj</Button>
        <Button variant="contained" style={{ flex: '0.45' }} type="submit">{_.isNil(positionToEdit) ? 'Dodaj opłate' : 'Edytuj opłatę'}</Button>
      </Stack>
    </form>
  );
};

const getRodzajPlatnosciString = platnosc => {
  let rodzaj = '';
  if (platnosc.payment_kind === PAYMENT_KINDS.KIND_YEARLY_FEE) {
    rodzaj = 'Roczna: ';
  } else if (platnosc.payment_kind === PAYMENT_KINDS.KIND_MONTHLY) {
    rodzaj = `${platnosc.regard_month}/${platnosc.regard_year}: `;
  }

  return (<b>{rodzaj}</b>);
};

export { getRodzajPlatnosciString, CreatePayment };


export default CreatePayment;
